<template>
  <Layer v-if="item !== null" :visible="true" @close="$emit('close')" title="Edit Item">
    <ProductTeaser :productId="item.productId" :compact="true" />

    <h6 class="ml-3 mt-4">Packed {{ item.packed || 0 }} / {{ item.amount }}</h6>
    <div class="list-group m-3">
      <button
        class="list-group-item list-group-item-action text-success"
        @click="
          () => {
            $emit('setPackedAmount', { index: item.itemIndex, amount: item.amount })
            $emit('close')
          }
        "
      >
        ✓ Set all packed
      </button>
      <button
        class="list-group-item list-group-item-action text-warning"
        @click="
          () => {
            $emit('setPackedAmount', { index: item.itemIndex, amount: 0 })
            $emit('close')
          }
        "
      >
        x Reset packing status
      </button>
    </div>

    <h6 class="ml-3 mt-4">Availability</h6>
    <div class="list-group m-3">
      <button
        class="list-group-item list-group-item-action text-warning"
        :disabled="item.notAvailable || !item.packed || item.packed < 1"
        v-if="!item.partiallyAvailable"
        @click="
          () => {
            $emit('setPartiallyAvailable', true)
            $emit('close')
          }
        "
      >
        x Mark item as partially available
      </button>
      <button
        :disabled="item.notAvailable || item.packed < 1"
        class="list-group-item list-group-item-action text-success"
        v-else
        @click="
          () => {
            $emit('setPartiallyAvailable', false)
            $emit('close')
          }
        "
      >
        ✓ Mark item as fully available
      </button>
      <button
        class="list-group-item list-group-item-action text-success"
        v-if="item.notAvailable"
        :disabled="item.partiallyAvailable"
        @click="
          () => {
            $emit('setAvailability', true)
            $emit('close')
          }
        "
      >
        ✓ Mark item as available
      </button>
      <button
        :disabled="item.partiallyAvailable"
        class="list-group-item list-group-item-action text-danger"
        v-else
        @click="
          () => {
            $emit('setAvailability', false)
            $emit('close')
          }
        "
      >
        ✗ Mark item as not available
      </button>
    </div>

    <!-- <h6 class="ml-3 mt-4">Receipt No.</h6>
    <div class="m-3 btn-group-lg">
      <button class="btn btn-primary btn-large mr-1">1</button>
      <button class="btn btn-outline-primary mr-1">2</button>
    </div> -->

    <button style="margin: 1rem; float: right;" class="btn btn-primary" @click="$emit('close')">Done</button>
  </Layer>
</template>

<script>
import Layer from '@/shared/Layer'
import ProductTeaser from '@/components/ProductTeaser'

export default {
  components: { Layer, ProductTeaser },
  props: ['item']
}
</script>
